import {
  ERX_ADYEN_MP_TOGGLE,
  ERX_ADYEN_TOGGLE,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

export const isErxAdyenActive = (experiments: Experiment[] = []): boolean => {
  const experiment = getExperiment(ERX_ADYEN_TOGGLE, experiments)
  return Boolean(experiment.isEnabled)
}

export const isErxAdyenMpActive = (experiments: Experiment[] = []): boolean => {
  const experiment = getExperiment(ERX_ADYEN_MP_TOGGLE, experiments)
  return Boolean(experiment.isEnabled)
}
